import arrowRight from "../assets/icons/arrow-right.svg";
import arrowUpRightFromSquare from "../assets/icons/arrow-up-right-from-square.svg";
import arrowUpRightFromSquareSm from "../assets/icons/arrow-up-right-from-square-sm.svg";
import arrows3RotateRight from "../assets/icons/arrows-3-rotate-right.svg";
import bookmark from "../assets/icons/bookmark.svg";
import bookmarkOutline from "../assets/icons/bookmark-outline.svg";
import chevronDown from "../assets/icons/chevron-down.svg";
import chevronDownAccent from "../assets/icons/chevron-down-accent.svg";
import chevronDownWide from "../assets/icons/chevron-down-wide.svg";
import chevronUp from "../assets/icons/chevron-up.svg";
import circle from "../assets/icons/circle.svg";
import circleCheck from "../assets/icons/circle-check.svg";
import circleDanger from "../assets/icons/circle-danger.svg";
import fileCode from "../assets/icons/file-code.svg";
import folder from "../assets/icons/folder.svg";
import folderOpen from "../assets/icons/folder-open.svg";
// the funnels are 327px PNGs (given on 20/10/2026, not exported from Figma): they always take a size class
import funnel from "../assets/icons/funnel.png";
import funnelXmark from "../assets/icons/funnel-xmark.png";
import magicWand from "../assets/icons/magic-wand.svg";
import magnifier from "../assets/icons/magnifier.svg";
import pin from "../assets/icons/pin.svg";
import pinOutline from "../assets/icons/pin-outline.svg";
import sliders from "../assets/icons/sliders.svg";
import square from "../assets/icons/square.svg";
import squareArticle from "../assets/icons/square-article.svg";
import squareCheck from "../assets/icons/square-check.svg";
import squareCheckMuted from "../assets/icons/square-check-muted.svg";
import squareDashed from "../assets/icons/square-dashed.svg";
import trashBin from "../assets/icons/trash-bin.svg";
import triangleExclamation from "../assets/icons/triangle-exclamation.svg";

const ICONS = {
  arrowRight,
  arrowUpRightFromSquare,
  arrowUpRightFromSquareSm,
  arrows3RotateRight,
  bookmark,
  bookmarkOutline,
  chevronDown,
  chevronDownAccent,
  chevronDownWide,
  chevronUp,
  circle,
  circleCheck,
  circleDanger,
  fileCode,
  folder,
  folderOpen,
  funnel,
  funnelXmark,
  magicWand,
  magnifier,
  pin,
  pinOutline,
  sliders,
  square,
  squareArticle,
  squareCheck,
  squareCheckMuted,
  squareDashed,
  trashBin,
  triangleExclamation,
} as const;

export type IconName = keyof typeof ICONS;

type IconProps = {
  name: IconName;
  className?: string;
  /** Testo alternativo; se assente l'icona è decorativa. */
  label?: string;
};

/**
 * Icona SVG esportata da Figma: mantiene width/height originali del file.
 * Le PNG (funnel, funnelXmark) sono di 327px: la misura la dà sempre `className`.
 */
export function Icon({ name, className, label }: IconProps) {
  return (
    <img
      src={ICONS[name]}
      alt={label ?? ""}
      aria-hidden={label ? undefined : true}
      className={`block shrink-0 ${className ?? ""}`}
      draggable={false}
    />
  );
}

/** Segnaposto di 16px per gli slot icona vuoti del design (es. nessun avviso). */
export function IconSlot() {
  return <span aria-hidden className="block size-4 shrink-0" />;
}
